module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY2NjcgMTIuNjY2N0gzLjMzMzMzVjMuMzMzMzNIOFYySDMuMzMzMzNDMi41OTY2NyAyIDIgMi41OTY2NyAyIDMuMzMzMzNWMTIuNjY2N0MyIDEzLjQwMzMgMi41OTY2NyAxNCAzLjMzMzMzIDE0SDEyLjY2NjdDMTMuNDAzMyAxNCAxNCAxMy40MDMzIDE0IDEyLjY2NjdWOEgxMi42NjY3VjEyLjY2NjdaTTkuMzMzMzMgMlYzLjMzMzMzSDExLjcyMzNMNS4xNyA5Ljg4NjY3TDYuMTEzMzMgMTAuODNMMTIuNjY2NyA0LjI3NjY3VjYuNjY2NjdIMTRWMkg5LjMzMzMzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/link-icon.svg
// module id = 1978
// module chunks = 49